<template>
    <div>
        <collegeBanner></collegeBanner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
<!--                    <div class="row">-->
<!--                        <div class="col-md-4" v-if="this.$store.getters.getUser['business_activity'] == 'School'">-->
<!--                            <div class="db-stat-box">-->
<!--                                <div class="stat-details">-->
<!--                                    <div class="db-stat-icon">-->
<!--                                        <i class="fas fa-briefcase"></i>-->
<!--                                    </div>-->
<!--                                    <div class="db-stat-count">{{stats.quiz_count}}</div>-->
<!--                                    <div class="db-stat-heading">Quizzes Created</div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-md-4" v-if="this.$store.getters.getUser['business_activity'] == 'School'">-->
<!--                            <div class="db-stat-box">-->
<!--                                <div class="stat-details">-->
<!--                                    <div class="db-stat-icon">-->
<!--                                        <i class="far fa-building"></i>-->
<!--                                    </div>-->
<!--                                    <div class="db-stat-count">{{stats.pools_count}}</div>-->
<!--                                    <div class="db-stat-heading">Quiz Banks Created</div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-md-4" v-if="this.$store.getters.getUser['business_activity'] == 'School'">-->
<!--                            <div class="db-stat-box">-->
<!--                                <div class="stat-details">-->
<!--                                    <div class="db-stat-icon">-->
<!--                                        <i class="fas fa-list-ul"></i>-->
<!--                                    </div>-->
<!--                                    <div class="db-stat-count">{{stats.played_count}}</div>-->
<!--                                    <div class="db-stat-heading">Taken By Students</div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="row">-->
<!--                        <div class="col-md-12">-->
<!--                            <div class="view-all" v-if="this.$store.getters.getUser['business_activity'] != 'School'">-->
<!--                                <a href="javascript:;" @click="createClassModal(false)">Start Live Class</a>-->
<!--                            </div>-->
<!--                            <div class="view-all" v-if="this.$store.getters.getUser['business_activity'] != 'School'">-->
<!--                                <a href="javascript:;" @click="createClassModal(true)">Schedule Class</a>-->
<!--                                <CreateClassModal ref="classModal"></CreateClassModal>-->
<!--                            </div>-->
<!--                            <div class="view-all">-->
<!--                                <router-link to="/dashboard/create-quiz">Create Quiz</router-link>-->
<!--                            </div>-->
<!--                            <div class="view-all">-->
<!--                                <router-link to="/dashboard/create-quiz-bank">Create Quiz Bank</router-link>-->
<!--                            </div>-->
<!--                            <div class="view-all">-->
<!--                                <a href="javascript:;" @click="showModal()">Invite Students</a>-->
<!--                                <InviteCandidatesModal></InviteCandidatesModal>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="row" v-if="this.$store.getters.getUser['business_activity'] != 'School'">-->
<!--                        <div class="col-md-6">-->
<!--                            <h1 class="main-heading">Today’s Class Schedule</h1>-->
<!--                        </div>-->
<!--                        <div class="col-md-6">-->
<!--                            <button type="button" class="btn btn-primary reload-main" @click="getClasses()"><i-->
<!--                                    class="fas fa-sync-alt"></i></button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="row" v-if="this.$store.getters.getUser['business_activity'] != 'School'">-->
<!--                        <div class="col-md-12" v-if="todayClasses.length">-->
<!--                            <div class="col-md-6" v-for="cl in todayClasses">-->
<!--                                <div class="today-schedule"-->
<!--                                     :class="((cl.class_type == 'Live' || cl.seconds < 0) ? 'is-live' : '')">-->
<!--                                    <i class="fas fa-broadcast-tower"></i>-->
<!--                                    <h3 class="ts-title">{{cl.subject_name}}</h3>-->
<!--                                    <h4 class="ts-title">{{cl.course_name}} <span class="section"-->
<!--                                                                                  v-if="cl.section_name"> ({{cl.section_name}})</span>-->
<!--                                    </h4>-->
<!--                                    <span class="section">Semester {{cl.semester}}</span>-->
<!--                                    <p v-if="cl.class_type == 'Live'">Live Class</p>-->
<!--                                    <p v-else v-html="showTime(cl.start_time)+' to '+showTime(cl.end_time)">-->
<!--                                    </p>-->
<!--                                    <a class="join-button join" href="javascript:;" v-bind:data-key="cl.class_enc_id"-->
<!--                                       v-bind:data-date="cl.class_date" @click="broadCastClass($event)"-->
<!--                                       v-if="cl.is_started">-->
<!--                                        <span>Start Now</span>-->
<!--                                        <span>-->
<!--                                          <svg width="20px" height="12px" viewBox="0 0 66 43" version="1.1"-->
<!--                                               xmlns="http://www.w3.org/2000/svg"-->
<!--                                               xmlns:xlink="http://www.w3.org/1999/xlink">-->
<!--                                            <g id="arrow" stroke="none" stroke-width="1" fill="none"-->
<!--                                               fill-rule="evenodd">-->
<!--                                              <path class="one"-->
<!--                                                    d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"-->
<!--                                                    fill="#FFFFFF"></path>-->
<!--                                              <path class="two"-->
<!--                                                    d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"-->
<!--                                                    fill="#FFFFFF"></path>-->
<!--                                              <path class="three"-->
<!--                                                    d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"-->
<!--                                                    fill="#FFFFFF"></path>-->
<!--                                            </g>-->
<!--                                          </svg>-->
<!--                                        </span>-->
<!--                                    </a>-->
<!--                                    <a class="join-button" href="javascript:;" v-else>-->
<!--                                        <span>Stay Tuned</span>-->
<!--                                    </a>-->
<!--                                    <div class="count-number">-->
<!--                                        <span class="date" v-html="getDate(cl.class_date)"></span>-->
<!--                                        <span class="month" v-html="getMonth(cl.class_date)"></span>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-md-12" v-else>-->
<!--                            <h3>No classes scheduled today</h3>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="row"-->
<!--                         v-if="upcomingClasses.length && this.$store.getters.getUser['business_activity'] != 'School'">-->
<!--                        <div class="col-md-12">-->
<!--                            <h1 class="main-heading">Upcoming Lecture Schedule</h1>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="row" v-if="this.$store.getters.getUser['business_activity'] != 'School'">-->
<!--                        <div class="col-md-12">-->
<!--                            <div class="upcoming-schedule" v-if="upcomingClasses.length">-->
<!--                                <div class="schedule-listing" v-for="uc in upcomingClasses">-->
<!--                                    <div class="schedule-slot-time">-->
<!--                                        <div class="count-number">-->
<!--                                            <span class="date" v-html="getDate(uc.class_date)"></span>-->
<!--                                            <span class="month" v-html="getMonth(uc.class_date)"></span>-->
<!--                                        </div>-->
<!--                                        <span v-html="showTime(uc.start_time)"></span>-->
<!--                                        <span>to</span>-->
<!--                                        <span v-html="showTime(uc.end_time)"></span>-->
<!--                                    </div>-->
<!--                                    <div class="schedule-slot-info">-->
<!--                                        <h3 class="schedule-slot-title">-->
<!--                                            {{uc.subject_name}}-->
<!--                                        </h3>-->
<!--                                        <span>-->
<!--                                            {{uc.course_name}}-->
<!--                                        </span>-->
<!--                                        <span>({{uc.section_name}})</span>-->
<!--                                        <h5>Semester {{uc.semester}}</h5>-->
<!--                                        <i class="fas fa-broadcast-tower"></i>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="row padd-top-20" v-if="this.$store.getters.getUser['business_activity'] === 'School'">-->
<!--                        <div class="col-md-12">-->
<!--                            <div class="dash-inner-box">-->
<!--                                <div class="dashboard-heading">-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-md-6">-->
<!--                                            <h1>-->
<!--                                                Recently Added Quizzes-->
<!--                                            </h1>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-6">-->

<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="row padd-top-10">-->
<!--                                    <div class="col-md-12">-->
<!--                                        <div class="col-md-6" v-for="quiz in recentQuizzes">-->
<!--                                            <div class="today-schedule">-->
<!--                                                <i class="fas fa-puzzle-piece"></i>-->
<!--                                                <h3 class="ts-title">{{quiz.name}}</h3>-->
<!--                                                <h4 class="ts-title">{{quiz.total_questions}} Questions</h4>-->
<!--                                                <span class="section">Class {{quiz.class_name}} <p v-if="quiz.for_sections">({{quiz.for_sections}})</p></span>-->
<!--                                                <router-link class="join-button join" :to="{path: '/dashboard/quiz-detail?id=' + quiz.quiz_enc_id}">-->
<!--                                                    <span>Open</span>-->
<!--                                                    <span>-->
<!--                                          <svg width="20px" height="12px" viewBox="0 0 66 43" version="1.1"-->
<!--                                               xmlns="http://www.w3.org/2000/svg"-->
<!--                                               xmlns:xlink="http://www.w3.org/1999/xlink">-->
<!--                                            <g id="arrow" stroke="none" stroke-width="1" fill="none"-->
<!--                                               fill-rule="evenodd">-->
<!--                                              <path class="one"-->
<!--                                                    d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"-->
<!--                                                    fill="#FFFFFF"></path>-->
<!--                                              <path class="two"-->
<!--                                                    d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"-->
<!--                                                    fill="#FFFFFF"></path>-->
<!--                                              <path class="three"-->
<!--                                                    d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"-->
<!--                                                    fill="#FFFFFF"></path>-->
<!--                                            </g>-->
<!--                                          </svg>-->
<!--                                        </span>-->
<!--                                                </router-link>-->
<!--                                                <div class="count-number">-->
<!--                                                    <span class="date">{{quiz.total_marks}}</span>-->
<!--                                                    <span class="month">Marks</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="row padd-top-50" v-if="this.$store.getters.getUser['business_activity'] === 'School'">-->
<!--                        <div class="col-md-12">-->
<!--                            <div class="dash-inner-box">-->
<!--                                <div class="dashboard-heading">-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-md-6">-->
<!--                                            <h1>-->
<!--                                                Recently Added Quizzes Bank-->
<!--                                            </h1>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-6">-->

<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="row padd-top-10">-->
<!--                                    <div class="col-md-12">-->
<!--                                        <div class="col-md-6" v-for="qp in recentQuizzesBank">-->
<!--                                            <div class="today-schedule">-->
<!--                                                <i class="fas fa-puzzle-piece"></i>-->
<!--                                                <h3 class="ts-title">{{qp.name}}</h3>-->
<!--                                                <h4 class="ts-title">{{qp.question_count}} Questions</h4>-->
<!--&lt;!&ndash;                                                <span class="section">Section B</span>&ndash;&gt;-->
<!--                                                <a class="join-button join" href="javascript:;">-->
<!--                                                    <span>Open</span>-->
<!--                                                    <span>-->
<!--                                          <svg width="20px" height="12px" viewBox="0 0 66 43" version="1.1"-->
<!--                                               xmlns="http://www.w3.org/2000/svg"-->
<!--                                               xmlns:xlink="http://www.w3.org/1999/xlink">-->
<!--                                            <g id="arrow" stroke="none" stroke-width="1" fill="none"-->
<!--                                               fill-rule="evenodd">-->
<!--                                              <path class="one"-->
<!--                                                    d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"-->
<!--                                                    fill="#FFFFFF"></path>-->
<!--                                              <path class="two"-->
<!--                                                    d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"-->
<!--                                                    fill="#FFFFFF"></path>-->
<!--                                              <path class="three"-->
<!--                                                    d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"-->
<!--                                                    fill="#FFFFFF"></path>-->
<!--                                            </g>-->
<!--                                          </svg>-->
<!--                                        </span>-->
<!--                                                </a>-->
<!--                                                <div class="count-number">-->
<!--                                                    <span class="date">{{qp.label_name}}</span>-->
<!--&lt;!&ndash;                                                    <span class="month">Class</span>&ndash;&gt;-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CollegeSideNavLayout from './../../components/CollegeSideNavLayout.vue'
    import collegeBanner from './../../components/collegeBanner.vue'
    import InviteCandidatesModal from "../../components/InviteCandidatesModal";
    import CreateClassModal from "../../components/CreateClassModal";
    import axios from "axios";
    import toastr from "../../../public/js/toastr";
    import {requestHeaders, showLoader} from "../../_helpers/apiHelper";

    export default {
        components: {
            CollegeSideNavLayout,
            collegeBanner,
            InviteCandidatesModal,
            CreateClassModal,
        },
        data() {
            return {
                todayClasses: [],
                upcomingClasses: [],
                minSeconds: '',
                college_name: "",
                stats: [],
                recentQuizzes: [],
                recentQuizzesBank: [],
            }
        },
        mounted() {
            if (this.$store.getters.getUser['business_activity'] !== 'School') {
                // this.getClasses();
            } else {
                // this.getStats();
                // this.getRecentQuizzes();
                // this.getRecentQuizzesBank();
            }
        },
        methods: {
            showModal() {
                $('#inviteCandidateModal').modal('show');
            },
            createClassModal(t) {
                if (t) {
                    $('#createClassModal').modal('show');
                    this.$refs.classModal.modalFor(t);
                } else {
                    $('#createClassModal').modal('show');
                    this.$refs.classModal.modalFor(t);
                }
            },
            getClasses() {
                document.getElementsByClassName('reload-main')[0].children[0].classList += " fa-spin";
                var t = this;
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/classes/get-classes`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.todayClasses = response['data']['response']['data'];
                        t.timeDiff(response['data']['response']['data'][0]['class_date'], response['data']['response']['data'][0]['start_time'], response['data']['response']['data'][0]['end_time']);
                        if (response['data']['response']['data'][0]['seconds'] > 2) {
                            var timeLeft = response['data']['response']['data'][0]['seconds'] * 1000;
                            setTimeout(function () {
                                t.getClasses();
                            }, timeLeft)
                        }
                    }
                    document.getElementsByClassName('reload-main')[0].children[0].classList.remove('fa-spin');
                });
                axios.post(`${url}api/v2/classes/get-upcoming-classes`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.upcomingClasses = response['data']['response']['data'];
                    }
                });
            },
            broadCastClass(event) {
                var t = this;
                showLoader();
                var element = event.currentTarget;
                var url = this.$store.getters.getDomain;
                var data_date = element.getAttribute('data-date');
                var data_key = element.getAttribute('data-key');

                var data = {'class_id': data_key}
                axios.post(`${url}api/v2/classes/validate-session`, data, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.$router.push({path: '/dashboard/broadcast?cid=' + data_key + '&id=' + response['data']['response']['session_id']})
                    } else {
                        t.getToken(data_date, data_key);
                    }
                });
            },
            getToken(data_date, data_key, min = false) {
                var t = this;
                if (min) {
                    var data = {
                        'user_enc_id': t.$store.getters.getUser['user_id'],
                        'expire_time': 18000
                    }
                } else {
                    var data = {
                        'user_enc_id': t.$store.getters.getUser['user_id'],
                        'expire_time': t.minSeconds
                    }
                }
                axios.post(`https://www.sneh.eygb.me/api/v3/video-session/get-tokens`, data, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == true) {
                        t.startSession(data_date, data_key, response['data']['response']['session_id']);
                    } else {
                        toastr.error('Some error occurred. Try again later', 'Oops!!');
                    }
                });
            },
            startSession(date, key, id) {
                var t = this;
                var url = this.$store.getters.getDomain;
                var data = {
                    'expiry_date': date,
                    'class_id': key,
                    'session_id': id
                }
                axios.post(`${url}api/v2/classes/save-session`, {
                    data: data
                }, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.$router.push({path: '/dashboard/broadcast?cid=' + key + '&id=' + id})
                    } else {
                        toastr.error('Some error occurred. Try again later', 'Oops!!');
                    }
                });
            },
            getDate(e) {
                var d = new Date(e);
                return d.getDate();
            },
            getMonth(e) {
                var d = new Date(e);
                var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                return months[d.getMonth()];
            },
            showTime(e) {
                return e.replace(/:[^:]*$/, '');
            },
            timeDiff(date, start, end) {
                var startDate = new Date(date + " " + start);
                var endDate = new Date(date + " " + end);
                var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
                this.minSeconds = seconds;
            },
            getStats() {
                var t = this;
                var url = this.$store.getters.getDomain;
                axios.post(`${url}api/v2/quiz/teacher-stats`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.stats = response['data']['response']['data'];
                    }
                });
            },
            getRecentQuizzes() {
                var t = this;
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/quiz/get-teacher-quizzes`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.recentQuizzes = response['data']['response']['data'];
                    }
                });
            },
            getRecentQuizzesBank() {
                var t = this;
                var url = this.$store.getters.getDomain;
                axios.post(`${url}api/v2/quiz/teacher-quiz-pools`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.recentQuizzesBank = response['data']['response']['data'];
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .reload-main {
        background-color: #00a0e3;
        margin: 10px;
        float: right;
        margin-top: 25px;
        border-color: #00a0e3;
        border-radius: 10px 0px 10px 0;
    }

    .reload-main:hover {
        border-radius: 0px;
        -webkit-transition: .5s all;
        transition: .5s all;
        background-color: #00a0e3;
        border-color: #00a0e3;
    }

    .schedule-listing {
        display: inline-block;
        width: 50%;
        margin-bottom: 10px;
        transition: 0.5s;
    }

    .schedule-listing:hover .schedule-slot-time, .schedule-listing:hover .schedule-slot-info {
        -webkit-box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
        box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
    }

    .schedule-listing .schedule-slot-time {
        color: #fff;
        padding: 32px 15px;
        font-size: 15px;
        font-weight: 700;
        text-align: center;
        width: 35%;
        height: 115px;
        display: inline-block;
        position: relative;
        overflow: hidden;
        border: 1px dashed #00a0e3;
    }

    .schedule-listing:nth-child(odd) .schedule-slot-time {
        background: #0082b7;
    }

    .schedule-listing:nth-child(even) .schedule-slot-time {
        background: #00a0e3;
    }

    .schedule-slot-time > span {
        display: block;
    }

    /*.upcoming-schedule:nth-child(even) .schedule-listing:nth-child(odd) .schedule-slot-time {*/
    /*    background: #00a0e3;*/
    /*}*/
    /*.upcoming-schedule:nth-child(even) .schedule-listing:nth-child(even) .schedule-slot-time {*/
    /*    background: #0082b7;*/
    /*}*/

    .schedule-listing .schedule-slot-info {
        position: relative;
        padding: 9px 0px 15px 21px;
        border: 1px dashed #e5e5e5;
        border-left: none;
        width: 63%;
        display: inline-block;
        height: 115px;
        overflow: hidden;
    }

    .schedule-slot-info i {
        position: absolute;
        right: -10px;
        bottom: 0px;
        font-size: 55px;
        color: #bababa;
    }

    .schedule-slot-title {
        margin-bottom: 2px;
    }

    .schedule-slot-info h5 {
        margin-top: 2px;
    }

    .today-schedule {
        padding: 40px 40px 40px 50px;
        -webkit-box-shadow: 0px 20px 25px 0px rgba(0, 0, 0, 0.08);
        box-shadow: 0px 20px 25px 0px rgba(0, 0, 0, 0.08);
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -ms-border-radius: 5px;
        overflow: hidden;
        position: relative;
        background: #fff;
        z-index: 2;
        margin-bottom: 30px;
    }

    .today-schedule i {
        position: absolute;
        right: -10px;
        top: 20px;
        font-size: 55px;
        color: #bababa;
    }

    h3.ts-title {
        font-size: 24px;
        margin-bottom: 4px;
    }

    h4.ts-title {
        color: #777;
    }

    .today-schedule span.section {
        color: silver;
        text-transform: uppercase;
        margin-bottom: 10px;
        display: block;
    }

    h4.ts-title > span.section {
        display: inline-block;
    }

    .today-schedule p {
        margin-bottom: 0;
    }

    .today-schedule .count-number, .schedule-slot-time .count-number {
        position: absolute;
        left: -52px;
        top: -52px;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        -webkit-border-radius: 50%;
        -ms-border-radius: 50%;
        background: #00a0e3;
        color: #fff;
        display: block;
        text-align: left;
        font-size: 16px;
        font-weight: 700;
        padding-left: 63px;
        padding-top: 63px;
    }

    .today-schedule.is-live .count-number {
        background: #e45e05;
    }

    .schedule-slot-time .count-number {
        left: -58px;
        top: -58px;
        width: 115px;
        height: 115px;
        font-size: 14px;
        background: #fff;
        color: #00a0e3;
    }

    .count-number > span {
        display: block;
    }

    .count-number > span.date {
        margin-bottom: 0;
        margin-left: 10px;
    }

    .today-schedule {
        transition: 0.5s;
        -webkit-box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
        box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
    }

    .join-button {
        display: inline-block;
        padding: 10px 25px;
        text-decoration: none;
        position: relative;
        font-size: 15px;
        color: white;
        background: #00a0e3;
        border-radius: 20px;
        transition: 1s;
        box-shadow: 0px 7px 25px 0px rgba(0, 0, 0, 0.22);
        margin: 10px 0px;
    }

    .is-live .join-button {
        background: #e45e05;
    }

    .join-button.join {
        padding-right: 10px;
    }

    .join-button span:nth-child(2) {
        transition: 0.5s;
        margin-right: 0px;
    }

    .join-button:hover span:nth-child(2) {
        transition: 0.5s;
        margin-right: 20px;
    }

    .join-button span:nth-child(2) {
        width: 20px;
        margin-left: 10px;
        position: relative;
        top: 12%;
    }

    .today-schedule:hover {
        -webkit-box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.15);
        box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.15);
    }

    .today-schedule:hover > i {
        animation: shake 0.9s;
        animation-iteration-count: infinite;
    }

    @media screen and (max-width: 767px) {
        .schedule-listing {
            width: 100%;
        }
    }

    @keyframes shake {
        0% {
            transform: translate(1px, 1px) rotate(0deg);
        }
        10% {
            transform: translate(-1px, -2px) rotate(-1deg);
        }
        20% {
            transform: translate(-3px, 0px) rotate(1deg);
        }
        30% {
            transform: translate(3px, 2px) rotate(0deg);
        }
        40% {
            transform: translate(1px, -1px) rotate(1deg);
        }
        50% {
            transform: translate(-1px, 2px) rotate(-1deg);
        }
        60% {
            transform: translate(-3px, 1px) rotate(0deg);
        }
        70% {
            transform: translate(3px, 1px) rotate(-1deg);
        }
        80% {
            transform: translate(-1px, -1px) rotate(1deg);
        }
        90% {
            transform: translate(1px, 2px) rotate(0deg);
        }
        100% {
            transform: translate(1px, -2px) rotate(-1deg);
        }
    }

    /**************SVG****************/

    .join-button path.one {
        transition: 0.4s;
        transform: translateX(-60%);
    }

    .join-button path.two {
        transition: 0.5s;
        transform: translateX(-30%);
    }


    .join-button:hover path.one {
        transform: translateX(0%);
    }

    .join-button:hover path.two {
        transform: translateX(0%);
    }
    .today-schedule {
        -webkit-transition: 0.5s;
        transition: 0.5s;
        -webkit-box-shadow:  0px 6px 20px 0px rgba(0, 0, 0, 0.04);
        box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.04);
    }
</style>